import { render, staticRenderFns } from "./dataChangeHistory.vue?vue&type=template&id=311ffca9"
import script from "./dataChangeHistory.vue?vue&type=script&lang=js"
export * from "./dataChangeHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports